<div class="row mt-3">
  <div class="col-3">
    <div class="has-float-label">
      <label class="form-label">Template Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        name="templateName"
        type="text"
        class="form-control"
        id="templateName"
        disabled
        [(ngModel)]="templateName" />
    </div>
  </div>
  <!-- <div class="col-3">
    <div class="form-group has-float-label">
      <ng-select
        class="p-0"
        [(ngModel)]="itemType"
        (change)="itemTypeChange($event)"
      >
        <ng-option *ngFor="let com of itemTypeList" [value]="com">
          {{ com }}
        </ng-option>
      </ng-select>
      <label class="form-label">Item Type</label>
    </div>
  </div> -->
  <div class="form-check p-0 col-1 d-flex gap-2 align-items-end">
    <p-checkbox
      value="size"
      name="size"
      [binary]="true"
      [(ngModel)]="size"
      (change)="filterNumberAndFinishedGoods()" />
    <label class="form-check-label" for="check1"> Size </label>
  </div>
  <div class="form-check p-0 col-1 d-flex gap-2 align-items-end">
    <p-checkbox
      value="color"
      name="color"
      [binary]="true"
      [(ngModel)]="color"
      (change)="filterNumberAndFinishedGoods()" />
    <label class="form-check-label" for="check1"> Color </label>
  </div>
  <div class="form-check p-0 col-1 d-flex gap-2 align-items-end">
    <p-checkbox
      value="fit"
      name="fit"
      [binary]="true"
      [(ngModel)]="fit"
      (change)="filterNumberAndFinishedGoods()" />
    <label class="form-check-label" for="check1"> Style / Fit </label>
  </div>
  <div class="col-3">
    <div class="has-float-label">
      <label class="form-label">Vendor Reference</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        name="vendorReference"
        type="text"
        class="form-control"
        id="vendorReference"
        [(ngModel)]="vendorReference"
        (input)="setTemplateName()" />
    </div>
  </div>
  <div class="col-2">
    <div class="has-float-label">
      <label class="form-label">Store</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        name="store"
        type="text"
        class="form-control"
        id="store"
        [(ngModel)]="store"
        disabled />
    </div>
  </div>
</div>

<div class="row mt-3 d-flex align-items-center">
  <div class="col-3">
    <div class="has-float-label">
      <label class="form-label">Owner</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        name="ownerD365"
        type="text"
        class="form-control"
        id="ownerD365"
        [(ngModel)]="ownerD365"
        disabled />
    </div>
  </div>
  <div class="col-3">
    <div class="form-group has-float-label">
      <!-- <ng-select
        class="p-0"
        [(ngModel)]="itemNumber"
        (change)="itemNumberChange($event)"
      >
        <ng-option *ngFor="let com of items" [value]="com.itemNumber">
          {{ com.itemNumber }} - {{ com.name }}
        </ng-option>
      </ng-select> -->
      <label class="form-label">Item number</label>
      <p-select
        pInputText
        id="itemNumber"
        formControlName="itemNumber"
        [options]="items"
        (onChange)="itemNumberChange($event)"
        [showClear]="true"
        optionValue="itemNumber"
        optionLabel="itemNumber">
        <ng-template let-item pTemplate="item">
          {{ item.itemNumber }} - {{ item.name }}
        </ng-template>
      </p-select>
    </div>
  </div>
  <div class="col-3 d-flex align-items-end gap-2 mt-3">
    <!-- <button
      type="button"
      class="btn btn-primary me-2"
      (click)="addAllVariants()">
      Add All Variants
    </button>
    <button type="button" class="btn btn-primary" (click)="calculateNet()">
      Calculate Net
    </button> -->

    <p-button label="Add All Variants" (click)="addAllVariants()" />

    <p-button label="Calculate Net" (click)="calculateNet()" />
  </div>
</div>

<div>
  <jni-finished-goods-template-grid
    #finishedGoodsTemplateGrid
    [allReleasedProductsList]="allReleasedProductsList"
    [releasedProductsList]="releasedProductsList"
    [releasedProductsVariantsList]="releasedProductsVariantsList"
    [allReleasedProductsVariantsList]="allReleasedProductsVariantsList"
    [itemNumber]="itemNumber"></jni-finished-goods-template-grid>
  <jni-service-template-grid
    #servicesTemplateGrid
    (addNewServiceLine)="addNewServiceLine()"
    (editServiceLine)="editServiceLine($event)"></jni-service-template-grid>
</div>

<div class="row justify-content-end">
  <div class="col-auto">
    <!-- <button type="button" class="btn btn-primary" (click)="closeModal()">
      Cancel
    </button> -->

    <p-button label="Cancel" (click)="closeModal()" />
  </div>
  <div class="col-auto">
    <!-- <button type="button" class="btn btn-primary" (click)="createTemplate()">
      Create Template
    </button> -->

    <p-button label="Create Template" (click)="createTemplate()" />
  </div>
</div>

<jni-modal-stacker
  *ngIf="inventoryServiceLinesDisplayModal"
  [displayModal]="inventoryServiceLinesDisplayModal"
  (closeEvent)="closeModalFromInventoryServiceLines()"
  class="modal-header-sticky">
  <div class="panelBody">
    <!-- <jni-inventory-purchase-lines
      [purchaseOrderNumber]="samplePONumber"
      [fromStacker]="true"
      (closeEvent)="closeModalFromSamplePOSummary()"
    ></jni-inventory-purchase-lines> -->
    <jni-template-service-line-form
      [parent]="parent"
      [saleOrderIdFromModal]="saleOrderIdFromModal"
      [lineGroup]="lineGroup"
      [site]="site || ''"
      [warehouse]="warehouse || ''"
      [saleOrderModalStatus]="true"
      (closeEvent)="closeModalFromInventoryServiceLines()"
      (linesForTemplate)="serviceLines($event)"
      [serviceLineToEdit]="serviceLineToEdit"
      [createFinishedGoodTemplate]="true"
      [index]="index"
      (editedServiceLine)="
        editedServiceLine($event)
      "></jni-template-service-line-form>
  </div>
</jni-modal-stacker>
